import { useState, useContext, useEffect, } from "react";
import axios from "axios";
import { format } from "date-fns";
import CookieContext from "../contexts/CookieContext";
import AppContext from "../contexts/AppContext";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";

import { TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { FormGroup, FormControlLabel, CircularProgress, Switch } from '@mui/material';

const StyledButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #32dae6)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const WorkButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #f59f3e)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const DeleteButton = styled.button`
  width: 200px;
  color: ${'lightgray'};
  background: ${({ disabled }) => disabled ? 'linear-gradient(180deg, #666666, #999999)' : 'linear-gradient(180deg, #100c08, #ff0000)'};
  ${({ disabled }) => disabled && `text-shadow: #cccccc 5px 5px 10px; box-shadow: #cccccc 5px 5px 10px;`};
`;

const Item = () => {
  const { cookies } = useContext(CookieContext);
  const { apiHost, CancelButton, AppButtonRecordList } = useContext(AppContext);
  const basePath = 'item/';
  const [loading, setLoading] = useState(true);

  const [error, setError] = useState();
  const [items, setItems] = useState([]);
  const [recordLists, setRecordLists] = useState([]);
  const [records, setRecords] = useState([]);

  const [refresh, setRefresh] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [dataId, setDataId] = useState();
  const [dataIsActive, setDataIsActive] = useState(true);
  const [dataName, setDataName] = useState();
  const [dataDescription, setDataDescription] = useState();
  const [dataIpAddr, setDataIpAddr] = useState();
  const [dataUserId, setDataUserId] = useState();

  const [circularProgressOpen, setCircularProgressOpen] = useState(false);

  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [messageBoxTitle, setMessageBoxTitle] = useState('');
  const [messageBoxDescription, setMessageBoxMessage] = useState('');
 
  const [recordOpen, setRecordOpen] = useState(false);
  const [recordId, setRecordId] = useState('');
  const [recordTitle, setRecordTitle] = useState('');
  const [recordMessage, setRecordMessage] = useState('');


  const [formOpen, setFormOpen] = useState(false);
  const [deleteCheck, setDeleteCheck] = useState(false);
  const [deleteButtonDisabled, setDeleteButtonDisabled] = useState(true);
 
  const handleMessageBoxOpen = (title, message) => {
    setMessageBoxTitle(title);
    setMessageBoxMessage(message);
    setMessageBoxOpen(true);
  }

  const handleRecordOpen = (record_id) => {
    // ボタン押下反応
    setCircularProgressOpen(true);

    const recordDetail = async () => {
      // リフレッシュのための値を初期化
      // setRefresh(false);
      // alert('record_id: ' + record_id);
      setRecordTitle('record_id: ' + record_id);
      // setRecordMessage('record_id: ' + record_id);
  
      try {
        if (cookies.jwtAccess) {
          // jwtがある場合、headers（認証情報）有り
          const headers = {
            "Content-Type": "application/json",
            Authorization: `JWT ${cookies.jwtAccess}`,
          };
  
          const response = await fetch(
            `${apiHost}${basePath}record/${record_id}/`,
            { headers }
          );
  
          if (response.status === 200) {
            const data = await response.json();
            setRecords(data);
            // setRecordMessage(data.name);
            // setRecordMessage(data.record);
  
            let recordContext = "";
  
            // // {/* データリスト */}
            // recordContext += "<TableContainer>";
            // recordContext += '  <Table aria-label="simple table">';
            // recordContext += "    <TableHead>";
            // recordContext += "      <TableRow>";
            // recordContext += "        <TableCell>ID</TableCell>";
            // recordContext += "        <TableCell>チェック項目</TableCell>";
            // recordContext +=
            //   '        <TableCell align="left">チェック</TableCell>';
            // recordContext +=
            //   '        <TableCell align="left">チェック日時</TableCell>';
            // recordContext += "      </TableRow>";
            // recordContext += "      <br />";
            // recordContext += "    </TableHead>";
            // recordContext += "    <TableBody>";

            // {
            //   records.map((row, index) => {
            //     recordContext += "      <TableRow key=" + row.id + ">";
            //     recordContext +=
            //       '        <TableCell component="th" scope="row">' +
            //       row.id +
            //       "</TableCell>";
            //     recordContext +=
            //       '        <TableCell align="left">' + row.name + "</TableCell>";
            //     recordContext +=
            //       '        <TableCell align="left"><Checkbox checked=' +
            //       row.is_checked +
            //       " />" +
            //       row.is_checked.toString() +
            //       "</TableCell>";
            //     recordContext +=
            //       '        <TableCell align="left">' +
            //       row.checked_datetime +
            //       "</TableCell>";
            //     recordContext += "      </TableRow>";
            //     recordContext += "      <br />";
            //   })
            // }

            // recordContext += "    </TableBody>";
            // recordContext += "  </Table>";
            // recordContext += "</TableContainer>";

            // setRecordMessage(recordContext);

          } else if (response.status === 401) {
            setError("ログインしてください");
          } else {
            setError("エラー");
          }
        } else {
          setError("認証エラー");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setCircularProgressOpen(false);
      }
    };
  
    recordDetail();
  
    // setRecordId(record_id);
    setRecordOpen(true);
  };

  
  // データ更新用
  useEffect(() => {
    fetchitems();
    fetchrecorditems();
  }, [refresh]);

  const recordPost = async () => {
    alert('記録');
    // リフレッシュのための値を初期化
    setRefresh(false);

    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.post(`${apiHost}${basePath}record/`, 
          {
            name: 'noname',
          },
          {headers},
        )

        if (response.status === 201) {
          // handleMessageBoxOpen(response.data.id, '記録', '記録しました');
          handleMessageBoxOpen('記録', '記録しました');
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
    } catch (err) {
      console.log(err);
    }
  }

  const resetData = async() => {
    try {
      document.getElementById('name').value = '';
      setDataId('');
      setDataName('');
      setDataIpAddr('');
      setDataUserId('');
      setDeleteButtonDisabled(true);
    } catch (err) {
      console.log(err);
    }
  }

  const retrieveData = async(pk) => {
    // ボタン押下反応
    // setCircularProgressOpen(true);

    try {
      if (cookies.jwtAccess) {
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        };

        const response = await fetch(`${apiHost}${basePath}${pk}/`, {headers});
        // fetch成功時、status200
        if (response.status === 200) {
          const data = await response.json();

          // document.getElementById('name').value = data.name;

          setDataId(pk);
          setDataName(data.name);
          setDataDescription(data.description);
          setDataIsActive(data.is_active);
          setDataIpAddr(data.ip_addr);
          setDataUserId(data.user);
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
      // データ表示
      setFormOpen(true);
    } catch (err) {
      console.log(err);
    } finally {
      setCircularProgressOpen(false);
    }
  }

  const createData = async () => {
    // ボタン押下反応
    setCircularProgressOpen(true);

    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        var postData = {
          name: "新規",
          jwt_access: cookies.jwtAccess,
          access_token_username: cookies.accessTokenUsername,
          user: cookies.accessTokenUserId,
        }

        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.post(apiHost + basePath, postData, {headers});
        // post成功時、status201
        if (response.status === 201) {
          handleMessageBoxOpen('データ追加:' + response.data.id, 'データ追加が完了しました' + response.data.id);
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
      // 更新後の一覧表示
      setRefresh(true);
    } catch (err) {
      console.log(err);
    } finally {
      setCircularProgressOpen(false);
    }
  }

  const handleUpdate = async(pk) => {
    // ボタン押下反応
    setCircularProgressOpen(true);

    // リフレッシュのための値を初期化
    setRefresh(false);

    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        var postData = {
          is_active: dataIsActive,
          name: dataName,
          description: dataDescription,
          jwt_access: cookies.jwtAccess,
          access_token_username: cookies.accessTokenUsername,
          user: cookies.accessTokenUserId,
        }

        const response = await axios.put(apiHost + basePath + dataId + '/', postData, {headers});
        // put成功時、status200
        if (response.status === 200) {
          handleMessageBoxOpen('データ更新' + response.data.id, 'データ更新が完了しました' + response.data.id);
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
      setFormOpen(false);

      // 更新後の一覧表示
      setRefresh(true);
    } catch (err) {
      console.log(err);
    } finally {
      setCircularProgressOpen(false);
    }
  }

  const handleDelete = async(pk) => {
    // ボタン押下反応
    setCircularProgressOpen(true);

    // リフレッシュのための値を初期化
    setRefresh(false);
    try {
      if (cookies.jwtAccess) {
        // jwtがある場合、headers（認証情報）有り
        const headers = {
          'Content-Type': 'application/json',
          'Authorization': `JWT ${cookies.jwtAccess}`,
        }

        const response = await axios.delete(apiHost + basePath + dataId + '/', {headers});
        // delete成功時、status204
        if (response.status === 204) {
          handleMessageBoxOpen('データ削除' + dataId, 'データ削除が完了しました' + dataId);
          resetData();
        } else if (response.status === 401) {
          setError('ログインしてください');
        } else {
          setError('エラー');
        }
      } else {
        setError('認証エラー');
      }
      setFormOpen(false);

      // 更新後の一覧表示
      setRefresh(true);
    } catch (err) {
      console.log(err);
    } finally {
      setCircularProgressOpen(false);
    }
  }

  const fetchitems = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(apiHost + basePath, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setItems(data);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }

      setLoading(false);

    } catch (err) {
      console.log(err);
    }
  }

  const fetchrecorditems = async () => {
    try {
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `JWT ${cookies.jwtAccess}`,
      };

      const response = await fetch(`${apiHost}${basePath}record/`, {headers});

      if (response.status === 200) {
        const data = await response.json();
        setRecordLists(data);
      }
      else if (response.status === 401) {
        setError('ログインしてください');
      }
      else {
        setError('エラー');
      }
      setRefresh(true);
      setLoading(false);

  } catch (err) {
      console.log(err);
    }
  }


  const reload = () => {
    window.location.reload();
  }

  if(loading) return <p>Loading...</p>;
  if(error) return <><p className="errMsg">Error: {error ? error : error.message}<a href="">[再読込]</a></p><StyledButton onClick={reload}>再読込</StyledButton></>;

  return (
    <>
      <div><StyledButton onClick={recordPost}>記録</StyledButton></div>
      <div>
        {Array.isArray(recordLists)
          ? recordLists.map((recordList, index) => {
            // const parseJSON = JSON.parse(logChecklist.logchecklist);
            // console.log(parseJSON)
            return (
              <p>
                <AppButtonRecordList onClick={() => {handleRecordOpen(recordList.id)}}>
                【{recordList.id}】
                {format(recordList.created_at, "yyyy-MM-dd HH:mm:ss")}
                </AppButtonRecordList>
              </p>
            )
          })
          : null
        }
      </div>

      <div><WorkButton onClick={createData}>データ追加</WorkButton></div>

      <div>
        <Dialog
          open={circularProgressOpen}
          aria-labelledby="circular-progress-dialog-title"
          aria-describedby="circular-progress-dialog-description"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="circular-progress-dialog-title">
            Loading...
          </DialogTitle>
          <DialogContent>
            <CircularProgress />
          </DialogContent>
        </Dialog>

        <Dialog
          open={messageBoxOpen}
          aria-labelledby="message-box-dialog-title"
          aria-describedby="message-box-dialog-description"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="message-box-dialog-title">
            {messageBoxTitle}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="message-box-dialog-description">
              {messageBoxDescription}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <WorkButton onClick={() => {setMessageBoxOpen(false)}} autoFocus>OK</WorkButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={recordOpen}
          aria-labelledby="record-dialog-title"
          aria-describedby="record-dialog-description"
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle id="record-dialog-title">
            {recordTitle}
          </DialogTitle>
          <DialogContent>

            <DialogContentText id="record-dialog-message">
              {Array.isArray(records)
                ? records.map((record, index) => {
                  // const parseJSON = JSON.parse(logChecklist.logchecklist);
                  // console.log(parseJSON)
                  return (
                    <p>
                      <AppButtonRecordList onClick={() => {handleRecordOpen(record.id)}}>
                      【{record.id}】
                      {format(record.created_at, "yyyy-MM-dd HH:mm:ss")}
                      {record.record}
                      </AppButtonRecordList>
                    </p>
                  )
                })
                : null
              }
              {/* {recordMessage} */}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <WorkButton onClick={() => {setRecordOpen(false)}} autoFocus>OK</WorkButton>
          </DialogActions>
        </Dialog>

        <Dialog
          open={formOpen}
          aria-labelledby="form-dialog-title"
          aria-describedby="form-dialog-description"
          fullWidth
          maxWidth="sm"
          >
          <DialogTitle id="form-dialog-title">
            【{dataId}】{dataName}
          </DialogTitle>
          <DialogContent>
            <form onSubmit={handleSubmit} id="subscription-form">
              <div>
                <FormGroup>
                <FormControlLabel control={<Switch checked={dataIsActive} onClick={() => {setDataIsActive(!dataIsActive)}} />} label={dataIsActive ? "有効" : "無効" } />
                </FormGroup>
              </div>
              <div>
              【ID】{dataId}
              </div>
              <div>
              【名前】
              <TextField
                autoFocus
                required
                id="name"
                name="name"
                defaultValue={dataName}
                type="text"
                fullWidth
                variant="standard"
                onChange={(e) => setDataName(e.target.value)}
              />
              </div>
              <div>
              【詳細】
              <TextField
                id="description"
                name="description"
                defaultValue={dataDescription}
                type="text"
                fullWidth
                variant="standard"
                onChange={(e) => setDataDescription(e.target.value)}
              />
              </div>
            </form>
          </DialogContent>
          <DialogActions>
            <CancelButton onClick={() => {setFormOpen(false); resetData();}} autoFocus>キャンセル</CancelButton>
            <WorkButton onClick={() => handleUpdate(dataId)}>更新</WorkButton>
          </DialogActions>
          <DialogActions>
          <FormControlLabel
            control={<Switch defaultChecked={false} 
              onClick={() => {
                setDeleteCheck(!deleteCheck);
                setDeleteButtonDisabled(!deleteButtonDisabled);
              }} 
              color="error"
            />}
            // label="削除チェック"
            label={<span style={{ color: "#ff0000"}}>削除時チェック</span>}
            labelPlacement="top"
            />
          <DeleteButton disabled={deleteButtonDisabled} onClick={() => handleDelete(dataId)}>削除</DeleteButton>
          </DialogActions>
        </Dialog>
      </div>
      {/* データ一覧 */}
      {Array.isArray(items)
        ? items.map((item, index) => {
          return <StyledButton key={index} onClick={() => {retrieveData(item.id)}}>【{item.id}】{item.name}</StyledButton>
        })
        : null
      }
    </>
  )
}
export default Item
